import React, { useState, useEffect } from "react";
import ReactDOMServer from "react-dom/server";
import { FaEdit } from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import "@github/relative-time-element";

import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import TableControls from "../../../../components/tableControler/tableControler";
import "./style.css";

function RemitentesConsignatarios() {
  const [data, setData] = useState([]);
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");

  const filteredData = searchValue
    ? data.filter((d) =>
        (d.name || "").toUpperCase().includes(searchValue.toUpperCase())
      )
    : data;

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;

  const currentData = filteredData.slice(indexOfFirstData, indexOfLastData);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPageCount = Math.ceil(filteredData.length / dataPerPage);
  const pageNumbers = [];
  const maxPageNumbersToShow = 20;

  let startPage, endPage;
  if (totalPageCount <= maxPageNumbersToShow) {
    startPage = 1;
    endPage = totalPageCount;
  } else {
    startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    endPage = Math.min(totalPageCount, startPage + maxPageNumbersToShow - 1);

    if (endPage - startPage < maxPageNumbersToShow) {
      startPage = endPage - maxPageNumbersToShow + 1;
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const showEntries = (e) => {
    setDataPerPage(e.target.value);
  };

  const handleSearch = (value) => {
    setSearchValue(value.trim());
  };

  const getData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/shipper_consignees`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        // Combinar Remitentes y consignatarios con una propiedad tipo
        const shippersWithType = res.data.data.shippers.map((shipper) => ({
          ...shipper,
          type: "Remitentes",
        }));
        const consigneesWithType = res.data.data.consignees.map(
          (consignee) => ({
            ...consignee,
            type: "Consignatarios",
          })
        );

        const combinedData = [...shippersWithType, ...consigneesWithType];
        setData(combinedData);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  useEffect(() => {
    getData();
  }, [updateTrigger]);

  const updateRecord = async (data) => {
    try {
      const reactComponentHtml = ReactDOMServer.renderToString(
        <>
          <div className="row">
            <div className="col-sm-12">
              <form
                acceptCharset="UTF-8"
                id="formValidation"
                className="form-horizontal fv-form fv-form-bootstrap"
                autoComplete="off"
                encType="multipart/form-data"
                noValidate="novalidate"
              >
                <div className="tab-pane" id="tab1">
                  <div className="row">
                    {/* Nombre */}
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <label htmlFor="name" className="col-sm-12 text-start">
                          Nombre
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-12">
                          <input
                            id="name"
                            className={`form-control`}
                            placeholder="Nombre"
                            required
                            name="name"
                            type="text"
                            value={data.name}
                          />
                        </div>
                      </div>
                    </div>
                    {/* Número de cuenta */}
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <label
                          htmlFor="account_number"
                          className="col-sm-12 text-start"
                        >
                          Número de cuenta
                        </label>
                        <div className="col-sm-12">
                          <input
                            id="account_number"
                            className={`form-control`}
                            placeholder="Número de cuenta"
                            name="account_number"
                            type="text"
                            value={data.account_number}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {/* Dirección */}
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <label
                          htmlFor="address"
                          className="col-sm-12 text-start"
                        >
                          Dirección
                          <span>&nbsp;</span>
                        </label>
                        <div className="col-sm-12">
                          <input
                            id="address"
                            className={`form-control`}
                            name="address"
                            type="text"
                            value={data.address}
                          />
                        </div>
                      </div>
                    </div>
                    {/* Ciudad */}
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <label htmlFor="town" className="col-sm-12 text-start">
                          Ciudad
                          <span>&nbsp;</span>
                        </label>
                        <div className="col-sm-12">
                          <input
                            id="town"
                            className={`form-control`}
                            name="town"
                            type="text"
                            value={data.town}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {/* Estado */}
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <label htmlFor="state" className="col-sm-12 text-start">
                          Estado
                          <span>&nbsp;</span>
                        </label>
                        <div className="col-sm-12">
                          <input
                            id="state"
                            className={`form-control`}
                            name="state"
                            type="text"
                            value={data.state}
                          />
                        </div>
                      </div>
                    </div>
                    {/* City Code */}
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <label
                          htmlFor="city_code"
                          className="col-sm-12 text-start"
                        >
                          City Code
                          <span>&nbsp;</span>
                        </label>
                        <div className="col-sm-12">
                          <input
                            id="city_code"
                            className={`form-control`}
                            name="city_code"
                            type="text"
                            maxLength={3}
                            value={data.city_code}
                          />
                          <small
                            className="text-start"
                            style={{ float: "left", fontWeight: "bold" }}
                          >
                            Ejemplo: GDL
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {/* Country Code */}
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <label
                          htmlFor="country_code"
                          className="col-sm-12 text-start"
                        >
                          Country Code
                          <span>&nbsp;</span>
                        </label>
                        <div className="col-sm-12">
                          <input
                            id="country_code"
                            className={`form-control `}
                            maxLength="2"
                            name="country_code"
                            type="text"
                            value={data.country_code}
                          />
                          <small
                            className="text-start"
                            style={{ float: "left", fontWeight: "bold" }}
                          >
                            Ejemplo: MX
                          </small>
                        </div>
                      </div>
                    </div>
                    {/* Código Postal */}
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <label
                          htmlFor="zip_code"
                          className="col-sm-12 text-start"
                        >
                          Código Postal
                          <span>&nbsp;</span>
                        </label>
                        <div className="col-sm-12">
                          <input
                            id="zip_code"
                            className={`form-control`}
                            name="zip_code"
                            type="text"
                            value={data.zip_code}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {/* Teléfono */}
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <label htmlFor="phone" className="col-sm-12 text-start">
                          Teléfono
                          <span>&nbsp;</span>
                        </label>
                        <div className="col-sm-12">
                          <input
                            id="phone"
                            className={`form-control`}
                            name="phone"
                            type="text"
                            value={data.phone}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </>
      );
      let nameInput;
      let account_numberInput;
      let addressInput;
      let townInput;
      let stateInput;
      let city_codeInput;
      let country_codeInput;
      let zip_codeInput;
      let phoneInput;

      const result = await Swal.fire({
        title: "Actualizar Registro",
        html: reactComponentHtml,
        showDenyButton: true,
        confirmButtonText: "Actualizar",
        denyButtonText: "Cancelar",
        width: 1000,
        padding: "1px",
        color: "#000",
        backdrop: `
        rgba(0,0,0,0.8)
      `,
        customClass: {
          confirmButton: "btn-amc-blue",
          denyButton: "btn-cancel",
          title: "alert-title",
          popup: "alert-bg",
        },
        focusConfirm: false,
        didOpen: async () => {
          const popup = Swal.getPopup();
          nameInput = popup.querySelector("#name");
          account_numberInput = popup.querySelector("#account_number");
          addressInput = popup.querySelector("#address");
          townInput = popup.querySelector("#town");
          stateInput = popup.querySelector("#state");
          city_codeInput = popup.querySelector("#city_code");
          country_codeInput = popup.querySelector("#country_code");
          zip_codeInput = popup.querySelector("#zip_code");
          phoneInput = popup.querySelector("#phone");

          nameInput.onkeyup = (event) =>
            event.key === "Enter" && Swal.clickConfirm();
          account_numberInput.onkeyup = (event) =>
            event.key === "Enter" && Swal.clickConfirm();
          addressInput.onkeyup = (event) =>
            event.key === "Enter" && Swal.clickConfirm();
          townInput.onkeyup = (event) =>
            event.key === "Enter" && Swal.clickConfirm();
          stateInput.onkeyup = (event) =>
            event.key === "Enter" && Swal.clickConfirm();
          city_codeInput.onkeyup = (event) =>
            event.key === "Enter" && Swal.clickConfirm();
          country_codeInput.onkeyup = (event) =>
            event.key === "Enter" && Swal.clickConfirm();
          zip_codeInput.onkeyup = (event) =>
            event.key === "Enter" && Swal.clickConfirm();
          phoneInput.onkeyup = (event) =>
            event.key === "Enter" && Swal.clickConfirm();
        },
        preConfirm: async () => {
          const name = nameInput.value;
          const account_number = account_numberInput.value;
          const address = addressInput.value;
          const town = townInput.value;
          const state = stateInput.value;
          const city_code = city_codeInput.value;
          const country_code = country_codeInput.value;
          const zip_code = zip_codeInput.value;
          const phone = phoneInput.value;

          // Validación de campos
          if (!name) {
            Swal.showValidationMessage(`Nombre es requerido`);
            return false;
          }

          const record = {
            name: name,
            account_number: account_number,
            address: address,
            town: town,
            state: state,
            city_code: city_code,
            country_code: country_code,
            zip_code: zip_code,
            phone: phone,
          };

          let updateResponse;

          if (data.type === "Remitentes") {
            updateResponse = await axios.put(
              `${process.env.REACT_APP_URL_BACKEND}/api/v1/shipper_consignees/updateShip/${data.id}`,
              record,
              {
                headers: {
                  Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
                },
              }
            );
          } else if (data.type === "Consignatarios") {
            updateResponse = await axios.put(
              `${process.env.REACT_APP_URL_BACKEND}/api/v1/shipper_consignees/updateCon/${data.id}`,
              record,
              {
                headers: {
                  Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
                },
              }
            );
          }
          console.log(updateResponse);

          if (updateResponse.data.code === 1) {
            Swal.fire(
              "Actualizado!",
              "El registro ha sido actualizado.",
              "success"
            );
            setUpdateTrigger(!updateTrigger);
          } else {
            throw Error(updateResponse);
          }

          return true;
        },
      });

      // Si el usuario cancela, result.dismiss contendrá el valor "cancel"
      if (result.dismiss === "cancel") {
        Swal.fire("Cancelado", "No se realizo ninguna accion", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  const createRecord = async () => {
    try {
      const reactComponentHtml = ReactDOMServer.renderToString(
        <>
          <div className="row">
            <div className="col-sm-12">
              <form
                acceptCharset="UTF-8"
                id="formValidation"
                className="form-horizontal fv-form fv-form-bootstrap"
                autoComplete="off"
                encType="multipart/form-data"
                noValidate="novalidate"
              >
                <div className="tab-pane" id="tab1">
                  <div className="row">
                    {/* Nombre */}
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <label htmlFor="name" className="col-sm-12 text-start">
                          Nombre
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-12">
                          <input
                            id="name"
                            className={`form-control`}
                            placeholder="Nombre"
                            required
                            name="name"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                    {/* Número de cuenta */}
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <label
                          htmlFor="account_number"
                          className="col-sm-12 text-start"
                        >
                          Número de cuenta
                        </label>
                        <div className="col-sm-12">
                          <input
                            id="account_number"
                            className={`form-control`}
                            placeholder="Número de cuenta"
                            name="account_number"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {/* Dirección */}
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <label
                          htmlFor="address"
                          className="col-sm-12 text-start"
                        >
                          Dirección
                          <span>&nbsp;</span>
                        </label>
                        <div className="col-sm-12">
                          <input
                            id="address"
                            className={`form-control`}
                            name="address"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                    {/* Ciudad */}
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <label htmlFor="town" className="col-sm-12 text-start">
                          Ciudad
                          <span>&nbsp;</span>
                        </label>
                        <div className="col-sm-12">
                          <input
                            id="town"
                            className={`form-control`}
                            name="town"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {/* Estado */}
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <label htmlFor="state" className="col-sm-12 text-start">
                          Estado
                          <span>&nbsp;</span>
                        </label>
                        <div className="col-sm-12">
                          <input
                            id="state"
                            className={`form-control`}
                            name="state"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                    {/* City Code */}
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <label
                          htmlFor="city_code"
                          className="col-sm-12 text-start"
                        >
                          City Code
                          <span>&nbsp;</span>
                        </label>
                        <div className="col-sm-12">
                          <input
                            id="city_code"
                            className={`form-control`}
                            name="city_code"
                            type="text"
                            maxLength={3}
                          />
                          <small
                            className="text-start"
                            style={{ float: "left", fontWeight: "bold" }}
                          >
                            Ejemplo: GDL
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {/* Country Code */}
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <label
                          htmlFor="country_code"
                          className="col-sm-12 text-start"
                        >
                          Country Code
                          <span>&nbsp;</span>
                        </label>
                        <div className="col-sm-12">
                          <input
                            id="country_code"
                            className={`form-control `}
                            maxLength="2"
                            name="country_code"
                            type="text"
                          />
                          <small
                            className="text-start"
                            style={{ float: "left", fontWeight: "bold" }}
                          >
                            Ejemplo: MX
                          </small>
                        </div>
                      </div>
                    </div>
                    {/* Código Postal */}
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <label
                          htmlFor="zip_code"
                          className="col-sm-12 text-start"
                        >
                          Código Postal
                          <span>&nbsp;</span>
                        </label>
                        <div className="col-sm-12">
                          <input
                            id="zip_code"
                            className={`form-control`}
                            name="zip_code"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {/* Teléfono */}
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group">
                        <label htmlFor="phone" className="col-sm-12 text-start">
                          Teléfono
                          <span>&nbsp;</span>
                        </label>
                        <div className="col-sm-12">
                          <input
                            id="phone"
                            className={`form-control`}
                            name="phone"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                    {/* Remitente o Consignatario */}
                    <div className="col-md-6 col-sm-12">
                      <div className={`form-group`}>
                        <label htmlFor="type" className="col-sm-12 text-start">
                          Remitente o Consignatario
                          <span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-12">
                          <select
                            id="type"
                            className={`form-control`}
                            name="type"
                          >
                            <option value="selected">Selecciona...</option>
                            <option value="1">Remitente</option>
                            <option value="2">Consignatario</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </>
      );
      let nameInput;
      let account_numberInput;
      let addressInput;
      let townInput;
      let stateInput;
      let city_codeInput;
      let country_codeInput;
      let zip_codeInput;
      let phoneInput;
      let typeInput;

      const result = await Swal.fire({
        title: "Crear Registro",
        html: reactComponentHtml,
        showDenyButton: true,
        confirmButtonText: "Crear",
        denyButtonText: "Cancelar",
        width: 1000,
        padding: "1px",
        color: "#000",
        backdrop: `
          rgba(0,0,0,0.8)
        `,
        customClass: {
          confirmButton: "btn-amc-blue",
          denyButton: "btn-cancel",
          title: "alert-title",
          popup: "alert-bg",
        },
        focusConfirm: false,
        didOpen: async () => {
          const popup = Swal.getPopup();
          nameInput = popup.querySelector("#name");
          account_numberInput = popup.querySelector("#account_number");
          addressInput = popup.querySelector("#address");
          townInput = popup.querySelector("#town");
          stateInput = popup.querySelector("#state");
          city_codeInput = popup.querySelector("#city_code");
          country_codeInput = popup.querySelector("#country_code");
          zip_codeInput = popup.querySelector("#zip_code");
          phoneInput = popup.querySelector("#phone");
          typeInput = popup.querySelector("#type");

          nameInput.onkeyup = (event) =>
            event.key === "Enter" && Swal.clickConfirm();
          account_numberInput.onkeyup = (event) =>
            event.key === "Enter" && Swal.clickConfirm();
          addressInput.onkeyup = (event) =>
            event.key === "Enter" && Swal.clickConfirm();
          townInput.onkeyup = (event) =>
            event.key === "Enter" && Swal.clickConfirm();
          stateInput.onkeyup = (event) =>
            event.key === "Enter" && Swal.clickConfirm();
          city_codeInput.onkeyup = (event) =>
            event.key === "Enter" && Swal.clickConfirm();
          country_codeInput.onkeyup = (event) =>
            event.key === "Enter" && Swal.clickConfirm();
          zip_codeInput.onkeyup = (event) =>
            event.key === "Enter" && Swal.clickConfirm();
          phoneInput.onkeyup = (event) =>
            event.key === "Enter" && Swal.clickConfirm();
          typeInput.onkeyup = (event) =>
            event.key === "Enter" && Swal.clickConfirm();
        },
        preConfirm: async () => {
          const name = nameInput.value;
          const account_number = account_numberInput.value;
          const address = addressInput.value;
          const town = townInput.value;
          const state = stateInput.value;
          const city_code = city_codeInput.value;
          const country_code = country_codeInput.value;
          const zip_code = zip_codeInput.value;
          const phone = phoneInput.value;
          const type = parseInt(typeInput.value, 10); // Convertir a número

          const pattern = /^\d+(\.\d+)?$/;

          // Validación de campos
          if (!name) {
            Swal.showValidationMessage(`Nombre es requerido`);
            return false;
          }

          if (account_number && !pattern.test(account_number)) {
            Swal.showValidationMessage(
              "Por favor introduce un Número de cuenta válido"
            );
            return false;
          }

          if (phone && !pattern.test(phone)) {
            Swal.showValidationMessage(
              "Por favor introduce un Teléfono válido"
            );
            return false;
          }

          if (isNaN(type)) {
            Swal.showValidationMessage(
              `Selecciona Remitentes o Consignatarios`
            );
            return false;
          }

          const record = {
            name: name,
            account_number: account_number,
            address: address,
            town: town,
            state: state,
            city_code: city_code,
            country_code: country_code,
            zip_code: zip_code,
            phone: phone,
          };

          let updateResponse;
          if (type === 1) {
            updateResponse = await axios.post(
              `${process.env.REACT_APP_URL_BACKEND}/api/v1/shipper_consignees/createShip`,
              record,
              {
                headers: {
                  Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
                },
              }
            );
          } else if (type === 2) {
            updateResponse = await axios.post(
              `${process.env.REACT_APP_URL_BACKEND}/api/v1/shipper_consignees/createCon`,
              record,
              {
                headers: {
                  Authorization: `Bearer ${sessionStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
                },
              }
            );
          }

          if (updateResponse.data.code === 1) {
            Swal.fire("Creado!", "El registro ha sido Creado.", "success");
            setUpdateTrigger(!updateTrigger);
          } else {
            throw Error(updateResponse);
          }

          return true;
        },
        allowOutsideClick: () => !Swal.isLoading()
      });

      // Si el usuario cancela, result.dismiss contendrá el valor "cancel"
      if (result.dismiss === "cancel") {
        Swal.fire("Cancelado", "No se realizo ninguna accion", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  console.log("===============data=====================");
  console.log(data);
  console.log("====================================");

  return (
    <>
      <ScrollToTop />
      <div className="table-responsive">
        <div
          className="dataTables_wrapper dt-bootstrap4 no-footer"
          id="datatables_wrapper"
        >
          <div className="text-right mb-4 ">
            <button className="btnn " onClick={createRecord}>
              Añadir Remitentes y Consignatarios
            </button>
          </div>
          <TableControls
            onSearch={handleSearch}
            onEntriesChange={showEntries}
            liveSearch={true}
            debounceTime={500}
          />

          <div className="row">
            <div className="col-sm-12">
              <table
                className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
                role="grid"
                aria-describedby="datatables_info"
              >
                <thead>
                  <tr role="row">
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "343.25px" }}
                    >
                      Nombre
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "178.203px" }}
                    >
                      Tipo
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "180.766px" }}
                    >
                      Creado
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "81.2031px" }}
                    >
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.map((data) => (
                    <tr key={data.id}>
                      <td>{data.name}</td>
                      <td>{data.type}</td>
                      <td>
                        <relative-time datetime={data.created_at} lang="es" />
                      </td>
                      <td>
                        <FaEdit
                          className="btn-edit"
                          onClick={() => {
                            updateRecord(data);
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="row">
            <nav aria-label="Page navigation example">
              <ul className="pagination">
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                </li>
                {pageNumbers.map((pageNumber) => (
                  <li className="page-item" key={pageNumber}>
                    <button
                      className="page-link"
                      onClick={() => paginate(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                ))}
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === pageNumbers.length}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
}

export default RemitentesConsignatarios;
